import { useState } from 'react';
import { AlertOctagon, Loader2 } from 'lucide-react';
import ModalShell from '../../components/ui/ModalShell';
import { CHYBA, tint, Tlacitko } from './ui';

/**
 * Potvrzení, že zákazník nebyl zastižen.
 *
 * Dva pokusy (rozhodnuto 2026-10-11): poprvé jde zákazníkovi SMS a zastávka
 * se přesune na konec trasy; podruhé (`zastavka.pokusu >= 1`) se objednávka
 * vrací do bistra.
 */
export default function NezastizenModal({ zastavka, onConfirm, onClose, isDark }) {
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState(null);

    if (!zastavka) return null;
    const druhy = (zastavka.pokusu ?? 0) >= 1;

    const potvrdit = async () => {
        setBusy(true);
        setErr(null);
        try {
            await onConfirm();
        } catch (e) {
            setErr(e?.message || String(e));
        } finally {
            setBusy(false);
        }
    };

    return (
        <ModalShell open onClose={onClose} zavritLze={!busy} isDark={isDark} nadpis="Nezastižen" ikona={AlertOctagon} barva={CHYBA}
            paticka={
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 10 }}>
                    <Tlacitko onClick={onClose} disabled={busy}>Zrušit</Tlacitko>
                    <Tlacitko plne barva={CHYBA} onClick={potvrdit} disabled={busy}>
                        {busy && <Loader2 size={18} className="animate-spin" />}
                        {druhy ? 'Zpět do bistra' : 'Nezastižen'}
                    </Tlacitko>
                </div>
            }>
            <div style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 12 }}>
                <div style={{ fontSize: 18, fontWeight: 900 }}>
                    {zastavka.jmeno || 'Zákazník'} · {zastavka.adresa || '—'}
                </div>
                <div style={{ fontSize: 15, lineHeight: 1.45, color: 'var(--text-secondary)' }}>
                    {druhy
                        ? 'Nezastižen ani podruhé. Objednávka jede zpět do bistra — uvidíš ji ve shrnutí jízdy.'
                        : 'Zákazníkovi odejde SMS a zastávka se přesune na konec trasy. Až na ni dojedeš, zavolej mu.'}
                </div>
                {err && (
                    <div style={{ padding: '10px 12px', borderRadius: 12, fontSize: 13, fontWeight: 700, background: tint(CHYBA, 0.12), border: `1px solid ${tint(CHYBA, 0.45)}` }}>{err}</div>
                )}
            </div>
        </ModalShell>
    );
}
